export default __webpack_public_path__ + "static/livesay-e1ba6580d9b02c27798ebe48df741686.jpg";